<template>
  <a-modal :width="750" :open="open" @cancel="closeForm" :footer="null" class="modal-no-padding" :wrap-class-name="isMobile ? 'ant-modal-bottom-wrap' : ''">
    <div class="modal-no-padding__header">
      <h2>
        Изменение роли
        <template v-if="user">
          —
          <a
              class="staff-role-user-link"
              :href="'/staff/' + user.user_id + '/edit'"
              target="_blank"
              rel="noopener noreferrer"
          >
            {{ user.name }}
          </a>
        </template>
      </h2>
    </div>

    <a-divider style="margin: 16px 0"/>

    <div class="modal-no-padding__body">
      <a-radio-group v-model:value="roleForm.role" class="role-group">
        <a-card v-if="getRight('superadmin')" class="role-card">
          <a-radio value="superadmin" class="radio-title">Суперадмин</a-radio>
          <div class="grey-text">
            Суперадмин
          </div>
        </a-card>

        <a-card v-if="getRight('superadmin')" class="role-card">
          <a-radio value="admin" class="radio-title">HR Администратор</a-radio>
          <div class="grey-text">
            Главный администратор с полным доступом к системе
          </div>
        </a-card>

        <a-card class="role-card">
          <a-radio value="hr_department" class="radio-title">HR Подразделения</a-radio>
          <div class="grey-text">
            Управляет выбранными группами и продуктами в пределах лимитов
          </div>

          <div v-if="roleForm.role === 'hr_department'">
            <div class="admin-group-select">
              <div class="additional-label">Управление группами</div>
              <a-select
                  v-model:value="roleForm.groups"
                  mode="multiple"
                  :placeholder="'Не выбрано'"
                  :not-found-content="'Нет данных'"
                  class="admin-group"
              >
                <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
                  {{ e.name }}
                </a-select-option>
              </a-select>
            </div>

            <div class="additional-label">
              Продукты и лимиты
            </div>

            <div v-if="quotasLoaded" class="order-list">
              <a-table
                  :columns="getExtendedColumns('tests', 'Оценка')"
                  rowKey="id"
                  :data-source="tableData.tests"
                  :table-layout="'fixed'"
                  :scroll="{ x: '100%' }"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot() }"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'free'">
                    <span class="free-quotas">
                      {{ text }}
                    </span>
                  </template>

                  <template v-if="column.dataIndex === 'quota'">
                    <a-input-number
                        class="input-number"
                        v-model:value="record.limit"
                        :min="0"
                        :max="100"
                        :placeholder="'10'"
                    />
                  </template>

                  <template v-if="column.dataIndex === 'has_access'">
                    <a-checkbox v-model:checked="record.access" :disabled="!record.limit"/>
                  </template>
                </template>
              </a-table>

              <a-table
                  :columns="getExtendedColumns('courses', 'Развитие (курсы, практикумы, тренажеры)')"
                  rowKey="id"
                  :data-source="tableData.courses"
                  :scroll="{ x: '100%' }"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot() }"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'free'">
                    <span class="free-quotas">
                      {{ text }}
                    </span>
                  </template>

                  <template v-if="column.dataIndex === 'quota'">
                    <a-input-number
                        class="input-number"
                        v-model:value="record.limit"
                        :min="0"
                        :max="100"
                        :placeholder="'10'"
                    />
                  </template>

                  <template v-if="column.dataIndex === 'has_access'">
                    <a-checkbox v-model:checked="record.access" :disabled="!record.limit"/>
                  </template>
                </template>
              </a-table>

              <a-table
                  v-if="tableData.subscriptions.length"
                  :columns="getExtendedColumns('subscriptions', 'Подписки')"
                  rowKey="id"
                  :data-source="tableData.subscriptions"
                  :scroll="{ x: '100%' }"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot() }"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'free'">
                    <span class="free-quotas">
                      {{ text }}
                    </span>
                  </template>

                  <template v-if="column.dataIndex === 'quota'">
                    <a-input-number
                        class="input-number"
                        v-model:value="record.limit"
                        :min="0"
                        :max="100"
                        :placeholder="'10'"
                    />
                  </template>

                  <template v-if="column.dataIndex === 'has_access'">
                    <a-checkbox v-model:checked="record.access" :disabled="!record.limit"/>
                  </template>
                </template>
              </a-table>

              <a-table
                  :columns="getShortListColumns('analytics', 'Просмотр аналитических отчетов')"
                  rowKey="id"
                  :data-source="tableData.analytics"
                  :scroll="{ x: '100%' }"
                  :pagination="false"
                  :locale="{ emptyText: emptySlot() }"
                  :table-layout="'fixed'"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'free'">
                    <span class="free-quotas">
                      {{ text }}
                    </span>
                  </template>

                  <template v-if="column.dataIndex === 'has_access'">
                    <a-checkbox v-model:checked="record.access"/>
                  </template>
                </template>
              </a-table>
            </div>

            <div class="loading-block" v-else>
              <a-spin/>
            </div>
          </div>
        </a-card>

        <a-card class="role-card">
          <a-radio value="staff" class="radio-title">Сотрудник</a-radio>
          <div class="grey-text">
            Видит свои результаты, проходит назначенные курсы
          </div>
        </a-card>
      </a-radio-group>
    </div>

    <a-divider style="margin: 16px 0"/>

    <div class="modal-no-padding__footer">
      <div class="button-row-full">
        <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
        <a-button :loading="isProcessing" class="primary-button" @click="handleRoleChange">
          Применить
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { computed, h, onBeforeMount, onBeforeUnmount, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { InfoCircleFilled, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import { getWordFormBasedOnTheCount } from "@/views/Report/utils";
import getReportName from "@/mixins/getReportName";
import { message } from "ant-design-vue";
import useCheckRights from "../../mixins/useCheckRights";
import useBreakpoints from "@/mixins/useBreakpoints";

export default {
  methods: { getWordFormBasedOnTheCount },
  components: {
    InfoCircleFilled,
    ExclamationCircleOutlined,
    PlusOutlined,
  },
  emits: ["close", "submitted"],
  props: {
    role: String,
    open: Boolean,
    userId: [Number, String],
    user: {
      type: Object,
      default: null,
    },
    managingGroups: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    const store = useStore();
    const { getRight } = useCheckRights();

    const roleForm = reactive({
      role: props.role,
      groups: [],
    });

    const isProcessing = ref(false);
    const quotasLoaded = ref(true);
    const groups = ref([]);

    const tableData = reactive({
      tests: [],
      courses: [],
      subscriptions: [],
      analytics: [],
    });

    const companyQuotas = computed(() => store.state.company.userQuotas);
    const adminQuotas = computed(() => store.state.hrAdmin?.adminQuotas ?? {});

    const allGroups = computed(() => store.state.group.groups);

    const getSavedTestLimit = (type) => {
      return (adminQuotas.value?.tests ?? []).find((item) => item.type === type);
    };

    const getSavedCourseLimit = (courseId) => {
      return (adminQuotas.value?.courses ?? []).find((item) => Number(item.course_id) === Number(courseId));
    };

    const getSavedSubscriptionLimit = (productId) => {
      return (adminQuotas.value?.subscriptions ?? []).find((item) => (
        Number(item.subscription_id) === Number(productId)
      ));
    };

    const getSavedReportLimit = (type) => {
      return (adminQuotas.value?.analytical_reports ?? []).find((item) => item.type === type);
    };

    const prepareData = () => {
      const testPassings = companyQuotas.value?.test_passings ?? {};
      const coursePassings = companyQuotas.value?.course_passings ?? {};
      const courseTotal = coursePassings?.total ?? {};
      const courseFree = coursePassings?.free ?? [];

      tableData.tests = Object.entries(testPassings)
          .filter(([key]) => key !== "empty")
          .map(([key, value]) => {
            const savedLimit = getSavedTestLimit(key);

            return {
              id: `test_${key}`,
              product: savedLimit?.title || getReportName(key),
              product_id: key,
              free: value?.free ?? 0,
              limit: savedLimit?.limit ?? 0,
              access: savedLimit?.access ?? false,
              sub_type: "tests",
            };
          });

      tableData.courses = Object.entries(courseTotal).map(([key, value]) => {
        const freePassings = courseFree.find((course) => Number(course.course_id) === Number(value.course_id));
        const savedLimit = getSavedCourseLimit(value.course_id);

        return {
          id: `course_${value.course_id ?? key}`,
          product: savedLimit?.title || value.name,
          product_id: value.course_id,
          free: freePassings?.count ?? 0,
          limit: savedLimit?.limit ?? 0,
          access: savedLimit?.access ?? false,
          sub_type: "courses",
        };
      });

      tableData.subscriptions = (companyQuotas.value?.subscriptions ?? []).map((subscription) => {
        const productId = subscription.id;
        const savedLimit = getSavedSubscriptionLimit(productId);

        return {
          id: `subscription_${productId}`,
          product: savedLimit?.title || subscription.title,
          product_id: productId,
          free: subscription.available ?? 0,
          limit: savedLimit?.limit ?? 0,
          monthly: savedLimit?.monthly ?? false,
          access: savedLimit?.access ?? false,
          sub_type: "subscriptions",
        };
      });

      const referenceProfileLimit = getSavedReportLimit("reference_profile");

      tableData.analytics = [
        {
          id: "analytics_reference_profile",
          product: "Эталонный профиль",
          product_id: "reference_profile",
          free: companyQuotas.value?.reference_profiles?.free_count ?? 0,
          access: referenceProfileLimit?.access ?? false,
          sub_type: "analytics",
        },
      ];
    };

    const loadQuotas = async () => {
      quotasLoaded.value = false;

      try {
        const requests = [
          store.dispatch("company/getUserQuotas"),
        ];

        if (roleForm.role === "hr_department" && props.userId) {
          requests.push(store.dispatch("hrAdmin/getAdminQuotas", { id: props.userId }));
        }

        await Promise.all(requests);
        prepareData();
      } catch (e) {
        message.error("Не удалось загрузить лимиты");
      } finally {
        quotasLoaded.value = true;
      }
    };

    const prepareGroups = async () => {
      await store.dispatch("group/getGroups");

      groups.value = allGroups.value.map((group) => ({
        id: group.id,
        name: group.name,
      }));

      roleForm.groups = (props.managingGroups ?? []).map((group) => {
        if (!groups.value.find((el) => Number(el.id) === Number(group.id))) {
          groups.value.push({
            id: group.id,
            name: group.name,
          });
        }

        return group.id;
      });
    };

    const handleRoleChange = () => {
      isProcessing.value = true;

      const isHrDepartment = roleForm.role === "hr_department";

      const tests = isHrDepartment
          ? (tableData.tests || []).map((item) => ({
            type: item.product_id,
            title: item.product,
            limit: item.limit ?? 0,
            access: item.access ?? false,
          }))
          : [];

      const courses = isHrDepartment
          ? (tableData.courses || []).map((item) => ({
            course_id: item.product_id,
            title: item.product,
            limit: item.limit ?? 0,
            access: item.access ?? false,
          }))
          : [];

      const analytical_reports = isHrDepartment
          ? (tableData.analytics || []).map((item) => ({
            type: item.product_id,
            access: item.access ?? false,
          }))
          : [];

      const subscriptions = isHrDepartment
          ? (tableData.subscriptions || []).map((item) => ({
            subscription_id: item.product_id,
            title: item.product,
            limit: item.limit ?? 0,
            monthly: item.monthly ?? false,
            access: item.access ?? false,
          }))
          : [];

      const updateObject = {
        user_id: props.userId,
        role: roleForm.role,
        groups: isHrDepartment ? (roleForm.groups ?? []) : [],
        tests,
        courses,
        subscriptions,
        analytical_reports,
      };

      store.dispatch("users/updateRole", updateObject)
          .then(() => {
            message.success("Роль обновлена");
            context.emit("submitted");
          })
          .catch(() => {
            message.error("Произошла ошибка");
          })
          .finally(() => {
            isProcessing.value = false;
          });
    };

    const closeForm = () => {
      store.dispatch("relations/clearInsufficientProducts");
      context.emit("close");
    };

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: "product",
          key: "product",
          width: 180,
          align: "left",
        },
        {
          title: "Остаток",
          dataIndex: "free",
          key: "free",
          width: 60,
          align: "right",
        },
        {
          title: "Лимит в месяц",
          dataIndex: "quota",
          key: "quota",
          width: 90,
          align: "right",
          customCell: () => ({ class: "quota-input-cell" }),
        },
        {
          title: "Доступ",
          dataIndex: "has_access",
          key: "has_access",
          width: 80,
          align: "right",
        },
      ];
    };

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: "product",
          key: "product",
          width: 240,
          align: "left",
        },
        {
          title: "Доступно",
          dataIndex: "free",
          key: "free",
          width: 80,
          align: "right",
        },
        {
          title: "Доступ",
          dataIndex: "has_access",
          key: "has_access",
          width: 80,
          align: "right",
        },
      ];
    };

    const emptySlot = () =>
        h("div", { class: "no-data-wrapper" }, [
          h("img", { src: NotFoundIcon, class: "no-data-image" }),
          h("div", { class: "no-data-text" }, "Нет данных для отображения"),
        ]);

    const { isMobile } = useBreakpoints();

    onBeforeMount(async () => {
      roleForm.role = props.role;
      await Promise.all([
        prepareGroups(),
        loadQuotas(),
      ]);
    });

    onBeforeUnmount(() => {
      store.commit('hrAdmin/clearAdminQuotas');
    });

    watch(
        () => props.role,
        (newRole) => {
          roleForm.role = newRole;
        }
    );

    watch(
        () => props.managingGroups,
        () => {
          roleForm.groups = (props.managingGroups ?? []).map((group) => group.id);
        },
        { deep: true }
    );

    watch(
        () => roleForm.role,
        async (newRole, oldRole) => {
          if (newRole === "hr_department" && oldRole !== "hr_department") {
            await loadQuotas();
          }
        }
    );

    return {
      getRight,
      roleForm,
      getExtendedColumns,
      getShortListColumns,
      emptySlot,
      closeForm,
      tableData,
      quotasLoaded,
      isMobile,
      handleRoleChange,
      isProcessing,
      groups,
    };
  },
};
</script>

<style lang="scss" scoped>
.radio-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
}

.staff-role-user-link {
  color: var(--main-green);
}

.form-group-row {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  row-gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 0;
  }
}

.input-form-item {
  min-width: 49%;
}

.password-radio-group,
.checkbox-group {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.password-field {
  margin: 10px;
}

:deep(.ant-input-focused) {
  border-color: var(--main-green);
}

.ant-input:hover,
.ant-input:focus {
  border-color: var(--main-green);
}

.ant-input:focus,
.ant-select-focused .ant-select-selector {
  box-shadow: 0 0 0 2px var(--polar-green);
}

.ant-input-affix-wrapper:hover,
.ant-input-affix-wrapper-focused {
  border-color: var(--main-green);
}

.ant-input-affix-wrapper-focused {
  box-shadow: 0 0 0 2px var(--polar-green);
}

:deep(.ant-form-item-label) {
  padding: 0;
}

:deep(.ant-form-item) {
  margin-bottom: 12px;
}

.button-row {
  display: flex;
  gap: 8px;

  justify-content: flex-end;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
  }
}

.successful-text {
  margin: 16px 0 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.successful-text p {
  margin-bottom: 0;
}

.successful-text span {
  font-size: 14px;
  color: var(--grey-text);
}

.successful-text .happy-smile,
.successful-text .frown-smile {
  font-size: 65px;
}

.successful-text .happy-smile {
  color: var(--main-green);
}

@media (max-width: $mobile-breakpoint) {
  .secondary-button {
    width: 100%;
  }
}

.free-quotas {
  color: var(--grey-text);
}

.order-list {
  --small-table-border-color: #f0f0f0;

  display: flex;
  flex-direction: column;
  row-gap: 10px;

  :deep(.ant-table-container) {
    overflow: hidden;
    border: 1px solid var(--small-table-border-color);
    border-radius: 8px;
  }

  :deep(.ant-table) {
    border-radius: 8px;
    font-size: 12px;
  }

  :deep(.ant-table-cell) {
    padding: 8px 12px !important;
    font-size: 12px;
    line-height: 16px;
  }

  :deep(.ant-table-thead > tr > th) {
    border-bottom: none !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    border-bottom: none;
  }

  :deep(.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody > tr:last-child > td) {
    border-bottom: none !important;
  }

  :deep(.ant-table-tbody > .ant-table-row > td),
  :deep(.ant-table-tbody > .ant-table-placeholder > td) {
    border-top: 1px solid var(--small-table-border-color);
  }

  :deep(.ant-table-tbody > .ant-table-measure-row > td) {
    border: 0 !important;
  }

  :deep(.quota-input-cell) {
    padding: 5px 10px !important;
  }

  :deep(.ant-input-number),
  :deep(.ant-input-number-input),
  :deep(.ant-checkbox-wrapper),
  :deep(.ant-btn) {
    font-size: 12px;
  }

  :deep(.ant-input-number) {
    display: inline-flex;
    align-items: center;
    height: 24px;
  }

  :deep(.ant-input-number-input-wrap) {
    display: flex;
    align-items: center;
    height: 100%;
  }

  :deep(.ant-input-number-input) {
    height: 100%;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 22px;
  }
}

:deep(.ant-input-number-input),
:deep(.ant-input-number-input::placeholder) {
  text-align: right;
}

:deep(.ant-input-number-handler-wrap) {
  display: none;
}

@media (max-width: $mobile-breakpoint) {
  :deep(.ant-input-number) {
    width: 50px !important;
  }
}

:deep(.group-select) {
  margin: 15px 0;
}

.role-group {
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .grey-text {
    font-size: 14px;
    padding-left: 25px;
  }

  .admin-group-select {
    margin: 16px 0;
    width: 100%;
  }
}

.button-row-full {
  margin-left: auto;
  display: flex;
  column-gap: 8px;
  row-gap: 10px;
  justify-content: flex-end;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;

    .ant-btn {
      width: 100%;
    }
  }
}

.additional-label {
  color: var(--grey-text);
  font-size: 14px;
  margin-bottom: 4px;
}

.admin-group {
  width: 100%;
}
</style>
